import { toast } from "react-toastify";
import { useState } from "react";
import { useSelector } from "react-redux";
import { linkAdsAccount } from "../../../../services/ApiService";
import { useNavigate } from "react-router-dom";

const TableClient = ({
  managerResults,
  managerId,
  setCustomerAccounts,
  fetchAdsAccountStatus,
  setShowAdsAccountsModal
}) => {
  // Define your headers
  const headers = [
    { label: "Sl.No", key: "sl.no" },
    { label: "Client Name", key: "descriptiveName" },
    { label: "Manager", key: "manager" },
    { label: "Actions", key: "actions" },
  ];
  const user = useSelector((state) => state?.user);
  const navigate=useNavigate()

  // State to track loading status and linked state of each button
  const [loading, setLoading] = useState({});
  const [linkedAccounts, setLinkedAccounts] = useState({});

  const handleManager = async (user_id, index) => {
    try{
          setLoading((prev) => ({ ...prev, [index]: true })); // Set loading for the specific button
    const data = await linkAdsAccount(managerId, user_id, user);

    if (data?.success) {
      toast.success(data?.message);
      setLinkedAccounts((prev) => ({ ...prev, [index]: true })); // Mark this account as linked
      navigate('/client/settings/integrations')
      fetchAdsAccountStatus();
      setShowAdsAccountsModal(false)
    } else {
      toast.error("Something went wrong");
      setShowAdsAccountsModal(false)
    }
    setLoading((prev) => ({ ...prev, [index]: false })); // Stop loading
    setCustomerAccounts([]);

    }catch(e)
    {
      console.log(e)
      toast.error("Something went wrong");
      setShowAdsAccountsModal(false)
    }

  };

  return (
    <div className="card-lg  bg-light">
      <div className="table-responsive text-nowrap card-body py-0">
        <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
          <thead>
            <tr className="fw-bold text-muted bg-light">
              {headers.map((header) => (
                <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                 {header.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {managerResults.length === 0 ? (
              <tr>
                <td colSpan={headers.length} className="text-center text-muted">
                  No data available
                </td>
              </tr>
            ) : (
              managerResults.map((account, index) => (
                <tr className="text-muted" key={index}>
                  <td>{index + 1}</td>
                  <td>{account.descriptiveName}</td>
                  <td>{account.manager ? "Yes" : "No"}</td>
                  <td className="d-flex justify-content-end">
                    <button
                      className="btn btn-sm rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center"
                      style={{width:"150px"}}
                      onClick={() => handleManager(account.id, index)}
                      disabled={
                        loading[index] || linkedAccounts[index] 
                      } // Disable if loading, already linked, or any account is linked
                    >
                      {loading[index] ? (
                        <span >Please Wait...</span>
                      ) : (
                        <span >
                          {linkedAccounts[index] ? "Linked" : "Link Account"}
                        </span>
                      )}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { TableClient };
